import { render, staticRenderFns } from "./ManageModules.vue?vue&type=template&id=179c2df5"
import script from "./ManageModules.vue?vue&type=script&lang=js"
export * from "./ManageModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports